import type { SvgElementProps } from '../../../types';

const IconMobilePlane = ({
  width = 33,
  height = 32,
  stroke = '#2B3240',
  themeColor,
  ...rest
}: SvgElementProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <g clip-path="url(#clip0_555_47071)">
      <path
        d="M27.0623 13.4012C28.6802 13.375 30.0059 14.6794 30.0059 16.2976C30.0059 17.8714 28.7493 19.1573 27.1759 19.1935L22.4832 19.3017C22.1154 19.3102 21.9315 19.3144 21.7659 19.3692C21.6194 19.4177 21.4839 19.4949 21.3674 19.5961C21.2358 19.7105 21.1383 19.8665 20.9433 20.1785L16.1918 27.7809C15.9917 28.1011 15.8916 28.2612 15.756 28.3774C15.6361 28.4802 15.4965 28.5576 15.3457 28.6048C15.1754 28.6582 14.9865 28.6582 14.6089 28.6582L13.9971 28.6582C12.9971 28.6582 12.497 28.6582 12.1958 28.4476C11.9329 28.2636 11.7573 27.9795 11.7104 27.6621C11.6567 27.2985 11.8803 26.8512 12.3275 25.9567L15.6435 19.3249L10.124 19.3249C9.79451 19.3249 9.62978 19.3249 9.47768 19.3668C9.34294 19.4039 9.21596 19.4649 9.10281 19.5469C8.97508 19.6395 8.87217 19.7682 8.66635 20.0254L7.45393 21.541C7.24811 21.7982 7.14521 21.9269 7.01748 22.0195C6.90432 22.1015 6.77734 22.1625 6.6426 22.1996C6.49051 22.2415 6.32577 22.2415 5.99631 22.2415L5.67044 22.2415C4.88993 22.2415 4.49968 22.2415 4.22633 22.0812C3.98657 21.9406 3.8049 21.719 3.71403 21.4563C3.61042 21.1568 3.68695 20.7741 3.84003 20.0088L4.48692 16.7743C4.51427 16.6376 4.52795 16.5692 4.5334 16.5002C4.53825 16.439 4.53825 16.3774 4.5334 16.3162C4.52795 16.2472 4.51427 16.1789 4.48692 16.0421L3.84002 12.8076C3.68695 12.0423 3.61042 11.6596 3.71403 11.3601C3.8049 11.0974 3.98657 10.8758 4.22633 10.7352C4.49968 10.5749 4.88993 10.5749 5.67044 10.5749L5.99631 10.5749C6.32577 10.5749 6.49051 10.5749 6.6426 10.6168C6.77734 10.6539 6.90432 10.7149 7.01748 10.7969C7.14521 10.8895 7.24811 11.0182 7.45393 11.2754L8.66635 12.791C8.87217 13.0482 8.97508 13.1769 9.10281 13.2695C9.21596 13.3515 9.34294 13.4125 9.47768 13.4496C9.62978 13.4915 9.79451 13.4915 10.124 13.4915L15.6435 13.4915L12.3275 6.85967C11.8803 5.96517 11.6567 5.51792 11.7104 5.15436C11.7573 4.83689 11.9329 4.55277 12.1958 4.36884C12.497 4.15821 12.997 4.15821 13.9971 4.15821H14.6089C14.9865 4.15821 15.1754 4.15821 15.3457 4.21159C15.4965 4.25883 15.6361 4.3362 15.756 4.43901C15.8916 4.55517 15.9917 4.71529 16.1918 5.03554L20.9252 12.609C21.1219 12.9238 21.2203 13.0811 21.3525 13.1958C21.4802 13.3065 21.6303 13.3881 21.7926 13.4351C21.9607 13.4837 22.1463 13.4807 22.5173 13.4747L27.0623 13.4012Z"
        stroke={themeColor || stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_555_47071">
        <rect width="32" height="32" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default IconMobilePlane;
